import React, { useEffect,useState,useRef,createRef } from "react";
import { getCookie } from '../../services/DataRequestService.js';
import { Link, useLocation } from "react-router-dom";
import UserService from "../../services/UserService.js";
import mmxlogo from "../../Assets/Images/logo.webp"
import getNotification from "../../Redux/Action/action.js";
import { useDispatch } from "react-redux";
import AuthService from "../../services/AuthService.js"
const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;

function Navbar3({scrollToSection}) {
  const usernameRef = useRef();
  const passwordRef = createRef();
  const agreementRef = useRef();

  const dispatch = useDispatch();
  const [logindata,setlogindata]=useState({})
const location=useLocation()
 
const submitLogin = () => {
  try {    
    if (agreementRef.current.checked) {
      AuthService.login({ username: usernameRef.current.value, password: passwordRef.current.value });
      console.log('success', 'Logged in Successfully', 'Logged in Successfully');
    }
    else {
      console.log('danger', 'Please accept Agreement', 'Terms and Conditions');
    }

  } catch(error) {
    console.log('danger', 'Please c Agreement', 'Terms and Conditions');
  }
}
const onClose=()=>{

}

  return (
    <>
    <div className="modal-overlay" onClick={onClose}></div>
 
 <div id="login" class="modal">
   
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body modal-body1">
            <div class="motit">
              <button type="button" class="close"><iconify-icon icon="material-symbols:close"></iconify-icon></button>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="loginwhitebg">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="loginiconbg">
                    <img src="/Assets/Images/loginicon1.webp"  class="max" alt="Revenue Radar" /><br />Login
                  </div>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="form-group1 my-2">
                  <input ref={usernameRef} type="text" class="form-control form-control1" id="username" placeholder="Enter Your username" />
                  </div>
                  <div class="form-group1">
                    <input ref={passwordRef} type="password" class="form-control form-control1" id="password" placeholder="Enter Your Password" />
                  </div>
                  <div class="forgotpwd">
                    <a href="#" aria-label="DE">Forgot Password?</a>
                  </div>
                  <div class="form-group">
                    <div class="checkbox mx-1 my-auto">
                      <label><input ref={agreementRef} className="mx-1 my-auto" type="checkbox" id="agreement" />I agree to the Terms of Service and Privacy Policy.</label>
                    </div>
                  
                  </div>
                  <div class="form-group">
                    <div class="connectbtn">
                      <a onClick={submitLogin} href='#' aria-label="DE">Login <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon></a></div>


                  </div>
                  <div class="noaccount">
                    <a href="#" aria-label="DE">Don’t Have An Account?</a>
                  </div>
                  <div class="createaccount">
                    <a onClick={""} className='open-signup' aria-label="DE">Create Account Now</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    <nav className="navbar navbar-expand-sm sticky-top" style={{ zIndex: 4 }}>
        <a className="navbar-brand " href="/">
          <img src={mmxlogo} style={{height:"50px"}} REACT_APP_UPLOAD_DATA />
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="">
          <div style={{width: "30px",height: "3px", backgroundColor:"#0A4742",margin:"6px"}}></div>
          <div style={{width: "30px",height: "3px", backgroundColor:"#0A4742",margin:"6px"}}></div>
          <div style={{width: "30px",height: "3px", backgroundColor:"#0A4742",margin:"6px"}}></div>
          </span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
         

       
          <ul className="navbar-nav mx-auto">
            
          {/* {location.pathname!=="/dashboard" && <>  <li
              className={
                UserService.isLoggedIn() ? "nav-item active" : "d-none"
              }
            >
              <Link className="nav-link" onClick={()=>{scrollToSection("overview")}}>
                <button className="btn   drk noborder" style={{  }}>
                  Overview
                </button>
              </Link>
            </li>
            
          
         
            </>} 
          
          {location.pathname!=="/dashboard" &&   <li
              className={UserService.isLoggedIn()?"nav-item-active":"d-none"}         
            >
              <Link className="nav-link" to="/dashboard">
                <button className="btn  drk noborder" style={{  }}>
                  Dashboard
                </button>
              </Link>
            </li>}
           
            <li
              className={
                UserService.isLoggedIn() ? "nav-item active" : "d-none"
              }
            >
              <Link className="nav-link" to="/support">
                <button className="btn  drk noborder" style={{  }}>
                  <i className="fa fa-user" aria-hidden="true"></i> Support
                </button>
              </Link>
            </li> */}
          {UserService.isLoggedIn() &&
          <>  <li
          className="nav-item-active"                
        >
          <Link className="nav-link " to="/dashboard">
            <button className="btn   noborder"  style={{color:"#015d52",fontWeight:"700"}}>
              Dashboard
            </button>
          </Link>
        </li>
        {/* <li
          className="nav-item-active"                
        >
          <Link className="nav-link " to="/updates">
            <button className="btn   noborder"  style={{color:"#015d52",fontWeight:"700"}}>
            Updates
            </button>
          </Link>
        </li> */}
        <li
          className="nav-item-active"                
        >
          <Link className="nav-link greentheme" to="/support">
            <button className="btn  drk noborder greentheme" style={{color:"#015d52",fontWeight:"700"}}>
              Support
            </button>
          </Link>
        </li>
     
        <li
          className="nav-item-active"                
        >
          <Link className="nav-link" to="/profile">
            <button className="btn  drk noborder" style={{color:"#015d52",fontWeight:"700"}}>
             My Profile
            </button>
          </Link>
        </li></>}
           
          

             
            
          </ul>
      <ul className="ml-auto navbar-nav">
      <li className="nav-item active my-auto">
   <Link className="nav-link">
   <div className=" " style={{color:"#015d52"}}>
                <i class="fa fa-bell"></i>
                </div></Link>
                </li>
                
              
            <li
              className={
                UserService.isLoggedIn() ? "d-none" : "  nav-item active"
              }
              
            >
              <Link
                className="nav-link"
           
                onClick={() => {
                  UserService.doLogin({
                    redirectUri:`${REACT_APP_REDIRECT_URI}/dashboard`,
                  })
                }}
   
              >
                <button className="btn noborder " style={{backgroundColor:"#015d52",color:"white",fontWeight:"700",borderRadius:"25px"}}>
                  Login <i className="fas fa-sign-in-alt"></i>
                </button>
              </Link>
            </li> 
      {/* <li
              className={
                UserService.isLoggedIn() ? "d-none" : "  nav-item active"
              }
              
            >
              <Link
                className="nav-link"
          data-toggle="modal" data-target="#login"
            
   
              >
                <button className="btn noborder " style={{backgroundColor:"#015d52",color:"white",fontWeight:"700",borderRadius:"25px"}}>
                  Login <i className="fas fa-sign-in-alt"></i>
                </button>
              </Link>
            </li> */}
            <li
              className={
                UserService.isLoggedIn() ? "d-none" : "nav-item active"
              }
            >
              <Link
                className="nav-link"
                onClick={() => UserService.doSignUp()}
              >
                <button className="btn noborder" style={{backgroundColor:"#2e835b",color:"white",fontWeight:"700",borderRadius:"25px"}}>
                   SignUp<i className="fas fa-user-plus mx-1"></i>
                </button>
              </Link>
            </li>
  
            <li
              className={
                UserService.isLoggedIn() ? "nav-item active" : "d-none"
              }
            >
              
                <div className=" mx-3 d-flex" style={{  }}>
               
                  <div className="d-flex justify-content-between align-items-center">
      
  
  <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="3em" 
    viewBox="0 0 23 23" 
    style={{ marginRight: '10px' }}
  >
    <path 
      fill="#015d52" 
  d="M15.71 12.71a6 6 0 1 0-7.42 0a10 10 0 0 0-6.22 8.18a1 1 0 0 0 2 .22a8 8 0 0 1 15.9 0a1 1 0 0 0 1 .89h.11a1 1 0 0 0 .88-1.1a10 10 0 0 0-6.25-8.19M12 12a4 4 0 1 1 4-4a4 4 0 0 1-4 4"></path></svg>
  <div className="greentheme">
    <p style={{ margin: 0 }}>Welcome to Revenue Radar</p>
    <p style={{ margin: 0,fontWeight:"500" }}  className="d-flex justify-content-between"> 
   <span>{ UserService.getUsername()?.toUpperCase() } </span> 
    <span className="position-relative" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
      <i className="fas fa-angle-down" ></i>
    <div
              className={
                UserService.isLoggedIn() ? "position-absolute collapse card align-center" : "d-none"
              }
              style={{top:"25px",right:"10px"}}
              id="collapseExample"
            >
               <Link
                className="nav-link"
                onClick={() => {
                  UserService.doLogout({
                    redirectUri: `${REACT_APP_REDIRECT_URI}`,
                  });
                  // console.log(UserService.getToken());
                }}
              >
                <button className="btn  drk noborder" style={{color:"#015d52"}}>
                  <i className="fas fa-sign-in-alt"></i> 
                </button>
              </Link>
              {/* <Link
                className="nav-link"
                onClick={() => {
                  AuthService.logout({
                    redirectUri: `${REACT_APP_REDIRECT_URI}`,
                  });
                  // console.log(UserService.getToken());
                }}
              >
                <button className="btn  drk noborder" style={{color:"#015d52"}}>
                  <i className="fas fa-sign-in-alt"></i> 
                </button>
              </Link> */}
            </div> </span></p>
    
             </div>
 
</div>
                
                </div>
            
          
            </li>
      </ul>
        </div>

     
      </nav>
    </>
  );
}

export default Navbar3;
